// Generated by purs version 0.14.4
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Enum_Extra from "../Data.Enum.Extra/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Functor_Extra from "../Data.Functor.Extra/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Record from "../Data.Record/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Symbol from "../Data.Symbol/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Exception from "../Effect.Exception/index.js";
import * as Foreign_Object from "../Foreign.Object/index.js";
import * as Restaumatic_Prelude_Specular from "../Restaumatic.Prelude.Specular/index.js";
import * as Specular_Dom_Builder from "../Specular.Dom.Builder/index.js";
import * as Specular_Dom_Element from "../Specular.Dom.Element/index.js";
import * as Specular_Dom_Widget from "../Specular.Dom.Widget/index.js";
import * as Specular_Extra_Switch from "../Specular.Extra.Switch/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
import * as Specular_FRP_Replaceable from "../Specular.FRP.Replaceable/index.js";
import * as Unsafe_Coerce from "../Unsafe.Coerce/index.js";
import * as Utils_JQuery from "../Utils.JQuery/index.js";
var Enabled = (function () {
    function Enabled() {

    };
    Enabled.value = new Enabled();
    return Enabled;
})();
var Disabled = (function () {
    function Disabled() {

    };
    Disabled.value = new Disabled();
    return Disabled;
})();
var DownloadButtonOptions = (function () {
    function DownloadButtonOptions(value0) {
        this.value0 = value0;
    };
    DownloadButtonOptions.create = function (value0) {
        return new DownloadButtonOptions(value0);
    };
    return DownloadButtonOptions;
})();
var Info = (function () {
    function Info() {

    };
    Info.value = new Info();
    return Info;
})();
var $$Error = (function () {
    function $$Error() {

    };
    $$Error.value = new $$Error();
    return $$Error;
})();
var Success = (function () {
    function Success() {

    };
    Success.value = new Success();
    return Success;
})();
var Warning = (function () {
    function Warning() {

    };
    Warning.value = new Warning();
    return Warning;
})();
var Alert = (function () {
    function Alert(value0) {
        this.value0 = value0;
    };
    Alert.create = function (value0) {
        return new Alert(value0);
    };
    return Alert;
})();
var testIdLegacyAdapterProp = {
    testId: Specular_Dom_Element.attr("data-testid")
};
var testIdLegacyAdapterAttrs = {
    testId: function (x) {
        return Foreign_Object.singleton("data-testid")(x);
    }
};
var whitespace = Specular_Dom_Element.text(" ");
var visibleIfDyn = function (dynCond) {
    return function (inner) {
        return Specular_FRP_Replaceable.dynamic_(Specular_Dom_Builder.monadReplaceBuilder)(Specular_FRP_Base.monadFRP(Specular_Dom_Builder.monadEffectBuilder)(Specular_Dom_Builder.monadCleanupBuilder))(Data_Functor.mapFlipped(Specular_FRP_Base.functorDynamic)(dynCond)(function (v) {
            if (v) {
                return inner;
            };
            return Restaumatic_Prelude_Specular.wempty;
        }));
    };
};
var toControlStateAttr = function (v) {
    if (v instanceof Disabled) {
        return Specular_Dom_Element.attr("disabled")("true");
    };
    return Data_Monoid.mempty(Specular_Dom_Element.monoidProp);
};
var testId = function (dict) {
    return dict.testId;
};
var specularToDomNode = Unsafe_Coerce.unsafeCoerce;
var primaryButton = Specular_Dom_Element.class_("btn btn-primary");
var mkAlert = function (alertType) {
    return function (message) {
        return new Alert({
            alertType: alertType,
            message: message
        });
    };
};
var successAlert = mkAlert(Success.value);
var warningAlert = mkAlert(Warning.value);
var labeledForm = function (txt) {
    return function (control) {
        return Control_Bind.discard(Control_Bind.discardUnit)(Specular_Dom_Builder.bindBuilder)(Specular_Dom_Element.el("label")([ Specular_Dom_Element.class_("control-label") ])(Specular_Dom_Element.text(txt)))(function () {
            return Control_Bind.discard(Control_Bind.discardUnit)(Specular_Dom_Builder.bindBuilder)(Specular_Dom_Element.el_("br")(Restaumatic_Prelude_Specular.wempty))(function () {
                return control;
            });
        });
    };
};
var itemToIndex = function (dictEnum) {
    return function (dictBounded) {
        return function (dictBoundedEnum) {
            return function (item) {
                return Data_Maybe.fromJust()(Data_Array.elemIndex((dictBounded.Ord0()).Eq0())(item)(Data_Enum_Extra.allEnumValues(dictBounded)(dictBoundedEnum.Enum1())));
            };
        };
    };
};
var infoAlert = mkAlert(Info.value);
var fileDownloadButton = function (v) {
    var mkParamInput = function (v1) {
        return Specular_Dom_Element.el("input")([ Specular_Dom_Element.attr("type")("hidden"), Specular_Dom_Element.attr("name")(v1.value0), Specular_Dom_Element.attr("value")(v1.value1) ])(Restaumatic_Prelude_Specular.wempty);
    };
    return Specular_Dom_Element.el("form")([ Specular_Dom_Element.attr("action")(Data_Record.getField(Data_Record.hasFieldRecord({
        reflectSymbol: function () {
            return "url";
        }
    })())(Data_Symbol.SProxy.value)(v.value0)), Specular_Dom_Element.attr("method")("get") ])(Control_Bind.discard(Control_Bind.discardUnit)(Specular_Dom_Builder.bindBuilder)(Data_Foldable.traverse_(Specular_Dom_Builder.applicativeBuilder)(Data_Foldable.foldableArray)(mkParamInput)(Data_Record.getField(Data_Record.hasFieldRecord({
        reflectSymbol: function () {
            return "params";
        }
    })())(Data_Symbol.SProxy.value)(v.value0)))(function () {
        return Specular_Dom_Element.el("button")([ Specular_Dom_Element.attr("type")("submit"), toControlStateAttr(Data_Record.getField(Data_Record.hasFieldRecord({
            reflectSymbol: function () {
                return "state";
            }
        })())(Data_Symbol.SProxy.value)(v.value0)) ])(Specular_Dom_Element.text(Data_Record.getField(Data_Record.hasFieldRecord({
            reflectSymbol: function () {
                return "label";
            }
        })())(Data_Symbol.SProxy.value)(v.value0)));
    }));
};
var errorAlert = mkAlert($$Error.value);
var domToSpecularNode = Unsafe_Coerce.unsafeCoerce;
var runWidgetInJQuery = function (jq) {
    return function (widget) {
        var v = Data_Array.head(Utils_JQuery.toArray(jq));
        if (v instanceof Data_Maybe.Just) {
            return Data_Functor.map(Effect.functorEffect)(Data_Tuple.fst)(Specular_Dom_Widget.runWidgetInNode(domToSpecularNode(v.value0))(widget));
        };
        if (v instanceof Data_Maybe.Nothing) {
            return Effect_Exception["throw"]("runWidgetInJQuery: Element not found: " + Data_Show.show(Data_Show.showString)(Utils_JQuery.selector(jq)));
        };
        throw new Error("Failed pattern match at Specular.Dom.Extra (line 54, column 3 - line 57, column 88): " + [ v.constructor.name ]);
    };
};
var controlButton = function (dynamicControlState) {
    return Control_Bind.bind(Specular_FRP_Base.bindDynamic)(dynamicControlState)(function (controlState) {
        return Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic)([ primaryButton, Specular_Dom_Element.attr("type")("submit"), toControlStateAttr(controlState) ]);
    });
};
var alertIconSign = function (v) {
    if (v instanceof Info) {
        return Specular_Dom_Element.class_("icon-info-sign");
    };
    if (v instanceof $$Error) {
        return Specular_Dom_Element.class_("icon-exclamation-sign");
    };
    if (v instanceof Success) {
        return Specular_Dom_Element.class_("icon-ok-sign");
    };
    if (v instanceof Warning) {
        return Specular_Dom_Element.class_("icon-warning-sign");
    };
    throw new Error("Failed pattern match at Specular.Dom.Extra (line 131, column 1 - line 131, column 35): " + [ v.constructor.name ]);
};
var alertClass = function (v) {
    if (v instanceof Info) {
        return Specular_Dom_Element.class_("alert alert-info");
    };
    if (v instanceof $$Error) {
        return Specular_Dom_Element.class_("alert alert-danger");
    };
    if (v instanceof Success) {
        return Specular_Dom_Element.class_("alert alert-success");
    };
    if (v instanceof Warning) {
        return Specular_Dom_Element.class_("alert alert-warning");
    };
    throw new Error("Failed pattern match at Specular.Dom.Extra (line 125, column 1 - line 125, column 32): " + [ v.constructor.name ]);
};
var alertBlock = function (dynAlert) {
    return Specular_FRP_Replaceable.dynamic_(Specular_Dom_Builder.monadReplaceBuilder)(Specular_FRP_Base.monadFRP(Specular_Dom_Builder.monadEffectBuilder)(Specular_Dom_Builder.monadCleanupBuilder))(Data_Functor_Extra["with"](Specular_FRP_Base.functorDynamic)(dynAlert)(function (v) {
        if (v instanceof Data_Maybe.Nothing) {
            return Restaumatic_Prelude_Specular.wempty;
        };
        if (v instanceof Data_Maybe.Just) {
            return Specular_Dom_Element.el("div")([ alertClass(Data_Record.getField(Data_Record.hasFieldRecord({
                reflectSymbol: function () {
                    return "alertType";
                }
            })())(Data_Symbol.SProxy.value)(v.value0.value0)) ])(Control_Bind.discard(Control_Bind.discardUnit)(Specular_Dom_Builder.bindBuilder)(Specular_Dom_Element.el("a")([ Specular_Dom_Element.class_("close"), Specular_Dom_Element.attr("data-dismiss")("alert"), Specular_Dom_Element.attr("href")("#") ])(Specular_Dom_Element.text("x")))(function () {
                return Specular_Dom_Element.el_("span")(Control_Bind.discard(Control_Bind.discardUnit)(Specular_Dom_Builder.bindBuilder)(Specular_Dom_Element.el("i")([ alertIconSign(Data_Record.getField(Data_Record.hasFieldRecord({
                    reflectSymbol: function () {
                        return "alertType";
                    }
                })())(Data_Symbol.SProxy.value)(v.value0.value0)) ])(Restaumatic_Prelude_Specular.wempty))(function () {
                    return Control_Bind.discard(Control_Bind.discardUnit)(Specular_Dom_Builder.bindBuilder)(Specular_Dom_Element.text("    "))(function () {
                        return Specular_Dom_Element.text(Data_Record.getField(Data_Record.hasFieldRecord({
                            reflectSymbol: function () {
                                return "message";
                            }
                        })())(Data_Symbol.SProxy.value)(v.value0.value0));
                    });
                }));
            }));
        };
        throw new Error("Failed pattern match at Specular.Dom.Extra (line 141, column 30 - line 149, column 29): " + [ v.constructor.name ]);
    }));
};
var actionVisibleIfDyn = function (dynCond) {
    return function (inner) {
        return Specular_Extra_Switch.dynamicSwitch(Specular_Extra_Switch.switchEvent)(Specular_Dom_Builder.monadReplaceBuilder)(Specular_FRP_Base.monadFRP(Specular_Dom_Builder.monadEffectBuilder)(Specular_Dom_Builder.monadCleanupBuilder))(Data_Functor.mapFlipped(Specular_FRP_Base.functorDynamic)(dynCond)(function (v) {
            if (v) {
                return inner;
            };
            return Control_Applicative.pure(Specular_Dom_Builder.applicativeBuilder)(Specular_FRP_Base.never);
        }));
    };
};
export {
    runWidgetInJQuery,
    whitespace,
    domToSpecularNode,
    specularToDomNode,
    actionVisibleIfDyn,
    visibleIfDyn,
    testId,
    fileDownloadButton,
    DownloadButtonOptions,
    Enabled,
    Disabled,
    Info,
    $$Error as Error,
    Success,
    Warning,
    Alert,
    mkAlert,
    infoAlert,
    errorAlert,
    successAlert,
    warningAlert,
    alertClass,
    alertIconSign,
    alertBlock,
    toControlStateAttr,
    primaryButton,
    controlButton,
    labeledForm,
    itemToIndex,
    testIdLegacyAdapterProp,
    testIdLegacyAdapterAttrs
};
//# sourceMappingURL=index.js.map
